export default "<style>\n\n</style>\n\n<keyboard-input-union> + </keyboard-input-union>";